module.exports = __webpack_public_path__ + "static/media/prf2.c07ee7b1.png";